import React, {Component} from 'react';
import {connect} from "react-redux";

class EidAuthenticationError extends Component {

    render() {
        if (!this.props.errorHappened)
            return null;

        return (
            <div id="eid-authentication-error" className="alert alert-error">
                <span class="kc-feedback-text">
                    {window.eidMessages.authenticationErrorHappened}
                </span>
            </div>
        )
    }

}

export default connect(
    (state) => {
        return {
            errorHappened: state.authentication.errorHappened || state.eid.errorHappened
        }
    },
    (dispatch) => {
        return {
            
        }
    }
)(EidAuthenticationError);


// WEBPACK FOOTER //
// ./src/components/EidAuthenticationError.js